// extracted by mini-css-extract-plugin
export default {"preRegisterWrap":"styles_preRegisterWrap__bk5PQ","button":"styles_button__PvmTy"};